/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { SkeletonParagraph } from '../../../../../components/common';
import { ESkeletonKind } from '../../../../../components/common/Skeleton/skeletonTypes';
import { SubscriberIdSkeletonStyled } from '../../styled/PageSubscriberIdStyled';
import { SubscriberIdProductPanelStyled } from './styled/SubscriberIdProductStyled';

const SubscriberIdProductsSkeleton = () => (
    <SubscriberIdSkeletonStyled>
        <SkeletonParagraph
            className="product-panel__date-connected"
            kind={ESkeletonKind.BUTTON_ROUND}
            style={{ height: '65px' }}
        />
        <SubscriberIdProductPanelStyled>
            <SkeletonParagraph className="product-panel__title" kind={ESkeletonKind.PARAGRAPH_SMALL}/>
            <SkeletonParagraph className="product-panel__price" kind={ESkeletonKind.PARAGRAPH_SMALL}/>
            <div className="product-panel__description">
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
            </div>
            <SkeletonParagraph className="product-panel__date-connected" kind={ESkeletonKind.BUTTON_ROUND}/>
        </SubscriberIdProductPanelStyled>
    </SubscriberIdSkeletonStyled>
);

export default SubscriberIdProductsSkeleton;
